import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Gram, PoundLb, Grain } from "./mass";
// Humidity
export var KilogramPerKilogram = UnitDivide.massByMass("KilogramPerKilogram", BaseUnits.Kilogram, BaseUnits.Kilogram);
export var GramPerKilogram = UnitDivide.massByMass("GramPerKilogram", Gram, BaseUnits.Kilogram);
export var PoundLbPerPoundLb = UnitDivide.massByMass("PoundLbPerPoundLb", PoundLb, PoundLb);
export var GrainPerPoundLb = UnitDivide.massByMass("GrainPerPoundLb", Grain, PoundLb);
export var GramPerPoundLb = UnitDivide.massByMass("GramPerPoundLb", Gram, PoundLb);
//# sourceMappingURL=humidity-ratio.js.map